import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import { FormControl, Input, InputLabel, MenuItem, Select } from '@mui/material';

import {
  getVehicleMakeAndModelInfo,
  receivedVehicleMakeAndModelInfo,
  getVehicleModelInfo,
  updateVehicleInfo,
} from '../../../actions';

import {
  ALL_CAR_MAKES,
  ALL_COLORS,
  BLACK,
  SELECT_MAKE,
  SELECT_MODEL,
  SELECT_COLOR,
  SELECT_YEAR,
  AUTO_TYPE,
  MILEAGE,
  MAZDA,
  VEHICLE_INFO_MAKE_MODEL_STYLE,
} from '../../../constants/Dashboard/Financing/auto';

import { FORM_CONTROL_FULL_WIDTH_INPUT_STYLE } from '../../../constants/Dashboard/Financing';

import './AutoFinancingSection.css';

export const AutoFinancingSection = ({ checkRates, resetValues, setVehicleYear, user }) => {
  const dispatch = useDispatch();

  const { MODELS, YEARS, AUTO_TYPES, model, year, auto_type, mileage, defaultColor, initialMake } =
    useSelector(
      ({
        vehicleReducer: { MODELS, YEARS, AUTO_TYPES, model, year, auto_type, mileage, color, make },
      }) => ({
        MODELS,
        YEARS,
        AUTO_TYPES,
        model,
        year,
        auto_type,
        mileage,
        defaultColor: color,
        initialMake: make,
      }),
    );

  const [make, setMake] = useState(initialMake);
  const [yearState, setYearState] = useState(year);
  const [color, setColor] = useState(defaultColor || BLACK);
  const [autoTypeState, setAutoType] = useState(auto_type);
  const [mileageState, setMileageState] = useState(mileage);

  useEffect(() => {
    if (checkRates) {
      dispatch((dispatch) =>
        updateVehicleInfo(dispatch, {
          make,
          color,
          auto_type: autoTypeState,
          mileage: mileageState,
        }),
      );
    }
  }, [checkRates]);

  useEffect(() => {
    if (make) {
      dispatch(getVehicleMakeAndModelInfo);
      dispatch(
        // TO DO - format better so we don't have to make an exception for Mazda
        receivedVehicleMakeAndModelInfo({
          make: make === MAZDA ? make.toUpperCase() : make.split('-').join('_'),
          user,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [make]);
  useEffect(() => {
    setAutoType((prevState) => {
      if (prevState !== auto_type) {
        return auto_type;
      }
      return prevState;
    });
  }, [auto_type]);

  useEffect(() => {
    setYearState((prevYearState) => {
      if (prevYearState !== year) {
        return year;
      }
      return prevYearState;
    });
    setVehicleYear((prevYear) => {
      if (prevYear !== year) {
        return year;
      }
      return prevYear;
    });
  }, [year]);

  useEffect(() => {
    if (resetValues) {
      setMake(ALL_CAR_MAKES[0]);
      setYearState(year);
      setColor(BLACK);
      setAutoType(auto_type);
      setMileageState('');
      if (MODELS[0] !== model) {
        // TO DO - think of another way - the model is different than the other
        // conventions here where it is stored in state
        dispatch((dispatch) => getVehicleModelInfo(dispatch, MODELS[0]));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetValues]);

  return (
    <>
      <div className="vehicle-info-row">
        <div className="financing-field-wrapper make">
          <InputLabel id="auto-financing-input-label">{SELECT_MAKE}</InputLabel>
          <FormControl sx={VEHICLE_INFO_MAKE_MODEL_STYLE}>
            <Select
              id="financing-select-helper"
              value={make}
              onChange={(e) => {
                setMake(e.target.value);
                dispatch((dispatch) =>
                  updateVehicleInfo(dispatch, {
                    make: e.target.value,
                  }),
                );
                mixpanel.track('Finance Section Auto', {
                  user_id: user.id,
                  financingType: 'AUTO',
                  FINANCE_FIELD: 'MAKE DROPDOWN',
                  MAKE: e.target.value,
                });
              }}
            >
              {ALL_CAR_MAKES.map((make) => (
                <MenuItem key={make} value={make}>
                  {make.split('_').join(' ')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="financing-field-wrapper model">
          <InputLabel id="auto-financing-input-label">{SELECT_MODEL}</InputLabel>
          <FormControl sx={VEHICLE_INFO_MAKE_MODEL_STYLE}>
            <Select
              id="financing-select-helper"
              value={model}
              onChange={(e) => {
                dispatch((dispatch) => getVehicleModelInfo(dispatch, e.target.value));
                mixpanel.track('Finance Section Auto', {
                  user_id: user.id,
                  financingType: 'AUTO',
                  FINANCE_FIELD: 'MODEL DROPDOWN',
                  MODEL: e.target.value,
                });
              }}
            >
              {MODELS.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="financing-field-wrapper year">
          <InputLabel id="auto-financing-input-label">{SELECT_YEAR}</InputLabel>
          <FormControl sx={VEHICLE_INFO_MAKE_MODEL_STYLE}>
            <Select
              id="financing-select-helper"
              value={yearState}
              onChange={(e) => {
                setYearState(e.target.value);
                setVehicleYear(e.target.value);
                mixpanel.track('Finance Section Auto', {
                  user_id: user.id,
                  financingType: 'AUTO',
                  FINANCE_FIELD: 'YEAR DROPDOWN',
                  YEAR: e.target.value,
                });
              }}
            >
              {YEARS.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="financing-field-wrapper color">
          <InputLabel id="auto-financing-input-label">{SELECT_COLOR}</InputLabel>
          <FormControl sx={VEHICLE_INFO_MAKE_MODEL_STYLE}>
            <Select
              id="financing-select-helper"
              value={color}
              onChange={(e) => {
                setColor(e.target.value);
                mixpanel.track('Finance Section Auto', {
                  user_id: user.id,
                  financingType: 'AUTO',
                  FINANCE_FIELD: 'COLOR DROPDOWN',
                  COLOR: e.target.value,
                });
              }}
            >
              {ALL_COLORS.map((color) => (
                <MenuItem key={color} value={color}>
                  {color}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="vehicle-info-row">
        <div className="financing-field-wrapper auto-type">
          <p className="auto-type-mileage-label">{AUTO_TYPE}</p>
          <FormControl sx={FORM_CONTROL_FULL_WIDTH_INPUT_STYLE}>
            <Select
              id="financing-select-helper"
              value={autoTypeState}
              onChange={(e) => {
                setAutoType(e.target.value);
                dispatch((dispatch) =>
                  updateVehicleInfo(dispatch, {
                    auto_type: e.target.value,
                  }),
                );
                mixpanel.track('Finance Section Auto', {
                  user_id: user.id,
                  financingType: 'AUTO',
                  FINANCE_FIELD: 'AUTO TYPE DROPDOWN',
                  AUTO_TYPE: e.target.value,
                });
              }}
            >
              {AUTO_TYPES.map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="financing-field-wrapper mileage">
          <p className="auto-type-mileage-label">{MILEAGE}</p>
          <FormControl sx={FORM_CONTROL_FULL_WIDTH_INPUT_STYLE}>
            <Input
              id="financing-select-helper"
              value={mileageState}
              autoComplete="off"
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setMileageState(e.target.value);
                  dispatch((dispatch) =>
                    updateVehicleInfo(dispatch, {
                      mileage: e.target.value,
                    }),
                  );
                  mixpanel.track('Finance Section Auto', {
                    user_id: user.id,
                    financingType: 'AUTO',
                    FINANCE_FIELD: 'MILEAGE INPUT',
                    MILEAGE: e.target.value,
                  });
                } else {
                  setMileageState('');
                }
              }}
              disableUnderline
            ></Input>
          </FormControl>
        </div>
      </div>
    </>
  );
};
